import ProjectListPage from "./pages/ProjectListPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import ProjectPhoneDirectoryPage from "./pages/ProjectPhoneDirectoryPage";
import ProjectBuildingStatusPage from "./pages/ProjectBuildingStatusPage";

export const projectRoutes = (prefix = "projects") => [
  {
    name: "ProjectDetailPage",
    path: `${prefix}/:id`,
    component: ProjectDetailPage,
    children: [
      {
        name: "ProjectPhoneDirectoryPage",
        path: `phone-directory`,
        component: ProjectPhoneDirectoryPage
      },
      {
        name: "ProjectBuildingStatusPage",
        path: `building-status`,
        component: ProjectBuildingStatusPage
      }
    ]
  },
  { name: "ProjectListPage", path: prefix, component: ProjectListPage }
];
